import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';

import {
  clientFamilyBackgroundActions,
  educationBackgroundActions,
  treatmentPlanActions,
} from '../../../../store';
import EducationBackground from './EducationBackground';
import ClientFamilyBackground from './ClientFamilyBackground';
import { TreatmentPlanPages } from '../constants/general';

import type { RootState } from '../../../../store';

function Background() {
  const dispatch = useDispatch();

  const { current: treatmentPlan } = useSelector((state: RootState) => state.treatmentPlans);

  const educationErrorCounts = useSelector(
    (state: RootState) => state.educationBackgrounds.errorCounts,
  );

  const {
    parentCaregiverErrorCounts,
    siblingErrorCounts,
    memberlanguageErrorCount,
    strengthErrorCount,
    interestErrorCount,
    familyBackgroundErrorCount,
  } = useSelector((state: RootState) => state.clientFamilyBackgrounds);

  // Set treatmentPlanId when treatmentPlan changes
  useEffect(() => {
    if (!treatmentPlan) return;

    dispatch(
      educationBackgroundActions.updateState({
        key: 'treatmentPlanId',
        data: treatmentPlan.id,
      }),
    );
    dispatch(
      clientFamilyBackgroundActions.updateState({
        key: 'treatmentPlanId',
        data: treatmentPlan.id,
      }),
    );
  }, [dispatch, treatmentPlan]);

  // Derive total error count
  const totalErrorCount = useMemo(() => {
    if (!treatmentPlan) return 0;

    return (
      (educationErrorCounts ?? 0) +
      (parentCaregiverErrorCounts ?? 0) +
      (siblingErrorCounts ?? 0) +
      (memberlanguageErrorCount ?? 0) +
      (strengthErrorCount ?? 0) +
      (interestErrorCount ?? 0) +
      (familyBackgroundErrorCount ?? 0)
    );
  }, [
    treatmentPlan,
    educationErrorCounts,
    parentCaregiverErrorCounts,
    siblingErrorCounts,
    memberlanguageErrorCount,
    strengthErrorCount,
    interestErrorCount,
    familyBackgroundErrorCount,
  ]);

  // Update badge when total changes
  useEffect(() => {
    dispatch(
      treatmentPlanActions.updateBadge({
        [TreatmentPlanPages.Background]: totalErrorCount,
      }),
    );
  }, [dispatch, totalErrorCount]);

  return (
    <Box>
      <EducationBackground />
      <ClientFamilyBackground />
    </Box>
  );
}

export default Background;
